import * as React from 'react';
import { EventName } from '@lit/react';
import { PdsSecondaryNavigationLink as PdsSecondaryNavigationLinkElement } from '@principal/design-system';
import { PdsSecondaryNavigationLinkProps } from '../../built-component-props';
import { createPdsReactComponent } from '../../create-pds-react-component';

export const PdsSecondaryNavigationLink =
  createPdsReactComponent<PdsSecondaryNavigationLinkProps>()({
    tagName: 'pds-secondary-navigation-link',
    elementClass: PdsSecondaryNavigationLinkElement,
    react: React,
    events: {
      onClick: 'pds-secondary-navigation-link-click' as EventName<CustomEvent>,
    },
  });
